import React, {useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import useOnClickOutside from "use-onclickoutside";

import * as actionTypes from "../../store/actions/actionTypes";
import * as modalActions from "../../store/actions/modal";
import ModalSelectDocumentSet_Actions from "./ModalSelectDocumentSet_Actions";
import UrDt from "../CustomLogic/UrDt";
import AdmDt from "../CustomLogic/AdmDt";

const ModalShowDocumentStatus = () => {
    const {show, admission, enableLoading, documents, payments} = useSelector(state => state.modal.documentStatus);
    const dispatch = useDispatch();
    const ref = React.useRef(null);
    useOnClickOutside(ref, () => hideModal());

    const hideModal = () => dispatch({type: actionTypes.MODAL_DOCUMENT_STATUS_HIDE});

    const renderDocumentSet = (document, key) => {

        return (
            <tr key={key}>
                <td>{document.title}</td>
                <td>{renderStatus(document.status)}</td>
                <td>{document.completedAt}</td>
            </tr>
        );
    }

    const renderStatus = (status) => {
        switch (status) {
            case "STATUS_NEW":
                return 'Sent to patient';
            case "STATUS_VIEWED":
                return 'Viewed by patient';
            case "STATUS_NEXT":
                return 'Pending';
            case "STATUS_COMPLETED":
                return 'Signed by patient';
            case "STATUS_CUTOFF":
                return 'Expired';
        }
    }

    const renderModal = () => {
        return (
            <div className="modal-dialog" role="document" ref={ref}>
            <div className="modal-content">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={hideModal}>
                    <span aria-hidden="true">×</span>
                </button>
                <div className="modal-body">
                    <h3>Documents status for for {admission.title} {admission.surname}, {admission.name}</h3>
                    <dl className="person-list mb-3">
                        <UrDt admission={admission}/>
                        <AdmDt admission={admission}/>
                    </dl>
                    <table className="table" cellSpacing="0" width="100%">
                        <thead>
                        <tr>
                            <th><strong className="title">Document</strong></th>
                            <th><strong className="title">Status</strong></th>
                            <th><strong className="title">Signed at</strong></th>
                        </tr>
                        </thead>
                        <tbody>
                        {documents.map(renderDocumentSet)}

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        );
    }

    return (
        <>
            <div className={`modal fade ${show ? 'show' : ''}`} id="documentStatusModal" tabIndex="-1">
                {show && renderModal()}
            </div>
        </>
    );
}

export default ModalShowDocumentStatus;